<div class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-24">
  <div class="orgApp-d-flex orgApp-justify-c-spc-btw">
    <h2 mat-dialog-title class="orgApp-duty-title">
      {{ editFormData.title | translate }}
    </h2>
    <button
      type="button"
      mat-icon-button
      class="orgApp-margin-right-16"
      (click)="cancelForm()"
    >
    <svg width="24" height="24">
      <use xlink:href="#close-icon"></use>
    </svg>
    </button>
  </div>
  <div>
    <mat-dialog-content
      class="orgApp-map-duty-content orgApp-padding-bottom-0 orgApp-padding-top-0 orgApp-padding-left-24 orgApp-padding-right-24"
    >
      <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-32 orgApp-map-duty-main-div">
        @if(loadDetails) {
          <div class="orgApp-map-duty-details-container">
            <div class="orgApp-padding-bottom-24 orgApp-padding-top-24 orgApp-padding-left-24 orgApp-padding-right-24 orgApp-map-duty-details-sub orgApp-d-flex orgApp-gap-16">
              <div class="orgApp-map-duty-details-icon-div orgApp-text-center">
                <div class="orgapp-shiftplanner-loader">
                  <div class="orgApp-d-flex orgApp-gap-16">
                      <ngx-skeleton-loader  class="orgapp-shiftplanner-loderIcon" appearance="circle"></ngx-skeleton-loader>
                      <ngx-skeleton-loader count="1" appearance="line" [theme]="{ width: '300px','border-radius': '3px', height: '16px','margin-bottom':'0px','margin-left':'0px','margin-top':'4px' }" ></ngx-skeleton-loader>
                  </div>
                </div>
                <ngx-skeleton-loader count="1" appearance="line" [theme]="{ width: '175px','border-radius': '3px', height: '16px','margin-bottom':'0px','margin-left':'50px','margin-top':'4px' }" ></ngx-skeleton-loader>
              </div>
            </div>
          </div>
        }
        @else {
          <div class="orgApp-map-duty-details-container">
            <div class="orgApp-padding-bottom-24 orgApp-padding-top-24 orgApp-padding-left-24 orgApp-padding-right-24 orgApp-map-duty-details-sub orgApp-d-flex orgApp-gap-16">
              <div class="orgApp-map-duty-details-icon-div orgApp-text-center">
                <div class="orgApp-map-duty-details-icon orgApp-d-flex orgApp-text-center orgApp-align-i-center orgApp-justify-c-center"  [ngStyle]="{ 'background-color': selectedDutyDetails.colourCode|| '#fff' }">
                  @if (selectedDutyDetails?.iconType === 'text') {
                    <span
                      class="orgApp-duty-text"
                      [ngStyle]="{ color: selectedDutyDetails?.iconColour || '#000' }"
                    >
                      {{ selectedDutyDetails?.icon }}
                    </span>
                  }
                  @else {
                    <svg
                      width="24"
                      height="24"
                      class="orgApp-padding-bottom-8 orgApp-padding-top-8 orgApp-padding-left-8 orgApp-padding-right-8"
                    >
                      <use [attr.xlink:href]="'#' + selectedDutyDetails?.icon"></use>
                    </svg>
                  }
                </div>
                <div class="orgApp-map-duty-details-icon-type">
                  {{ selectedDutyDetails?.dutyType }}
                </div>
              </div>
              <div class="orgApp-map-duty-details orgApp-d-flex orgApp-flex-dir-col orgApp-gap-16">
                <div class="orgApp-d-flex orgApp-flex-dir-col orgApp-gap-4 orgApp-padding-bottom-4 orgApp-map-duty-details-div">
                  <p class="orgApp-map-duty-details-title orgApp-map-duty-details-margin">
                    <b>{{ selectedDutyDetails?.name }}</b>
                  </p>
                  <p class="orgApp-sub-title-md orgApp-map-duty-details-margin">
                    {{ selectedDutyDetails?.description }}
                  </p>
                </div>
                <div class="orgApp-d-flex orgApp-gap-8 orgApp-padding-bottom-24 orgApp-map-duty-details-sub2">
                  <div *ngIf="selectedDutyDetails?.shiftType === 'FIRST_HALF_DAY_DUTY' || selectedDutyDetails?.shiftType === 'SECOND_HALF_DAY_DUTY'">
                    <span class="orgApp-shift-type-label">
                      {{ shiftTypeLabels[selectedDutyDetails?.shiftType] | translate }}
                    </span>
                  </div>
                  @if(selectedDutyDetails?.shiftType !== 'SECOND_HALF_DAY_DUTY'){
                    <div class="orgApp-map-duty-details-time-div orgApp-map-duty-details-border-radius orgApp-text-center">
                      {{ selectedDutyDetails?.firstSlotStartTime }} -
                      {{ selectedDutyDetails?.firstSlotEndTime }}
                    </div>
                  }
                  @if(!selectedDutyDetails?.continuous || (selectedDutyDetails?.shiftType === 'SECOND_HALF_DAY_DUTY')){
                    <div
                      class="orgApp-map-duty-details-time-div orgApp-map-duty-details-border-radius orgApp-text-center"
                    >
                      {{ selectedDutyDetails?.secondSlotStartTime }} -
                      {{ selectedDutyDetails?.secondSlotEndTime }}
                    </div>
                  }
                  @if(selectedDutyDetails?.shiftType === 'FULL_DAY_DUTY'){
                    <div
                      class="orgApp-map-duty-details-break-hr orgApp-padding-top-0 orgApp-padding-bottom-0 orgApp-padding-right-4 orgApp-padding-left-4 orgApp-map-duty-details-border-radius orgApp-text-center"
                    >
                      {{ selectedDutyDetails?.breakHours }}
                    </div>
                  }
                </div>
              </div>
              <button class="" mat-icon-button (click)="editDuty()">
                <svg width="24" height="24" [attr.viewBox]="(canEditDuty && (!isDutyMapped || isAppAdmin)) ? null : '0 0 16 16'">
                    <use [attr.xlink:href]="(canEditDuty && (!isDutyMapped||isAppAdmin)) ? '#pencil-icon-outlined' : '#arrow-grey-right'"></use>
                </svg>
              </button>
            </div>
          </div>
        }

        <div
          class="orgApp-gap-16 orgApp-flex-dir-col orgApp-d-flex orgApp-duties-in-week-container"
        >
          <form
            [formGroup]="dutyChartForm"
            class="orgApp-gap-16 orgApp-flex-dir-col orgApp-d-flex"
          >
            <div class="orgApp-d-flex orgApp-justify-c-spc-btw">
              <div class="orgApp-d-flex orgApp-gap-16">
                @if(!loadDetails) {
                  <mat-form-field
                    floatLabel="always"
                    class="orgApp-duties-in-week-common-input orgApp-duties-in-week-dropdown orgApp-md-disabled-field orgApp-field-rounded-sm orgApp-input-field orgApp-map-duty-field"
                    appearance="outline"
                  >
                  <span class="orgApp-md-i-placeholder">
                    {{ 'duties.map_duty_dialog.content.placeholder.department' | translate }}
                  </span>
                    <input matInput type="text" formControlName="department" />
                  </mat-form-field>
                }
                @else {
                  <div class="orgApp-empty-field-spacer">
                      <ngx-skeleton-loader count="1" appearance="line" [theme]="{ width: '125px','border-radius': '3px', height: '16px','margin-bottom':'0px','margin-left':'0px','margin-top':'6px' }" ></ngx-skeleton-loader>
                  </div>
                }
                @if(!loadDetails) {
                  <mat-form-field
                    floatLabel="always"
                    class="orgApp-duties-in-week-common-input orgApp-duties-in-week-dropdown orgApp-md-disabled-field orgApp-field-rounded-sm orgApp-input-field orgApp-map-duty-field"
                    appearance="outline"
                  >
                  <span class="orgApp-md-i-placeholder">
                    {{ 'duties.map_duty_dialog.content.placeholder.month' | translate  }}
                  </span>
                    <input matInput type="text" formControlName="month" />
                  </mat-form-field>
                }
              </div>
              @if((isAppAdmin||(showMemberData && !planningSheetPublished && canMapDuty && !isPrevMonth && (!dutyPublished))) && !loadDetails){
              <div>
                <button
                  mat-stroked-button [disabled]="!canMapDuty"
                  class="orgApp-duties-in-week-button orgApp-md-add-mem-row-btn"
                  (click)="addRow()"
                >
                <svg width="20" height="20" matPrefix>
                  <use [attr.xlink:href]="canMapDuty ? '#add-icon' : '#add-icon-disabled'"></use>
                </svg>
                  {{
                    'duties.map_duty_dialog.content.add_mem_row'
                      | translate
                  }}
                </button>
              </div>
              }
            </div>
            @if(loadDetails) {
               @for (item of [].constructor(3); track $index) {
                <div class="orgApp-d-flex orgApp-gap-8">
                  <ngx-skeleton-loader count="1" appearance="line" [theme]="{ width: '200px','border-radius': '3px', height: '20px','margin-bottom':'0px','margin-left':'0px','margin-top':'0px' }" ></ngx-skeleton-loader>
                  @for (item of [].constructor(8); track $index) {
                  <ngx-skeleton-loader count="1" appearance="line" [theme]="{ width: '75px','border-radius': '3px', height: '20px','margin-bottom':'0px','margin-left':'0px','margin-top':'0px' }" ></ngx-skeleton-loader>
                  }
                </div>
              }
            }
            @if(selectedDeptLength < 1 && !loadDetails){
            <div>
              <app-empty-member-table></app-empty-member-table>
            </div>
            } @if(selectedDeptLength > 0 && showMemberData && !loadDetails){
            <div #dutyRowElem>
              <ng-container formArrayName="dutyRows">
                <table
                  mat-table
                  [dataSource]="dataSource"
                  class="orgApp-duties-in-week-container"
                >
                  <ng-container matColumnDef="memberType">
                    <th
                      mat-header-cell
                      class="header-row-border orgApp-table-header-ht orgApp-duties-member-type-row"
                      *matHeaderCellDef
                    >
                      {{
                        "duties.map_duty_dialog.content.member_type" | translate
                      }}
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element; let i = index"
                      [ngClass]="{ disableTableRow: !element.value.active }"
                      [formGroup]="element"
                    >
                      @if(!editMemberType[i]){
                      <mat-form-field
                        floatLabel="always"
                        class="orgApp-duties-in-week-common-input orgApp-duties-in-week-dropdown orgApp-field-rounded-sm orgApp-input-field orgApp-map-duty-field"
                        appearance="outline"
                      >
                        <input
                          matInput
                          type="text"
                          formControlName="memberTypeId"
                          [disabled]="element.get('memberTypeId').disabled"
                        />
                      </mat-form-field>
                      } @else{
                      <mat-form-field
                        class="orgApp-duties-in-week-common-input orgApp-duties-in-week-dropdown orgApp-field-rounded-sm orgApp-input-field orgApp-map-duty-field"
                        appearance="outline"
                      >
                        <mat-select 
                          (selectionChange)="onOptionSelection($event)"
                          panelClass="orgApp-select-panel orgApp-dropdwn-opt"
                          placeholder="{{
                            'duties.map_duty_dialog.content.placeholder.select_member_type'
                              | translate
                          }}"
                          formControlName="memberTypeId" #memberTypeSelect
                           [disabled]="loadingMemberTypes">
                          <ng-container *ngIf="!loadingMemberTypes; else loadingTpl">
                          @for (data of memberTypeList; track data) {
                          <mat-option class="orgApp-dropdwn-opt"
                            [value]="data.id"
                            [disabled]="isMemberTypeDisabledForShift(data.id)"
                            >{{ data.name }}</mat-option
                          >
                          }
                          <hr />
                          <mat-option
                            class="orgApp-member-manage-option"
                            (click)="
                              $event.stopPropagation(); manageMemberType($event)
                            "
                          >
                            <div (click)="manageMemberType($event)">
                              <div class="orgApp-d-flex orgApp-align-i-center orgApp-gap-8">
                                <svg width="20" height="20">
                                  <use xlink:href="#add-icon-dark-blue"></use>
                                </svg>
                                <span>
                                  {{
                                  'duties.map_duty_dialog.content.mng_mem_type'
                                  | translate
                                  }}
                                </span>
                              </div>
                            </div>
                          </mat-option>
                         </ng-container>                   
                         <ng-template #loadingTpl>
                            <mat-option disabled class="orgApp-dropdwn-opt orgApp-map-duty-mtype-spinner">
                              <mat-progress-spinner diameter="24" mode="indeterminate">
                              </mat-progress-spinner>
                            </mat-option>
                          </ng-template>
                        </mat-select>
                      </mat-form-field>
                      }
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="monday">
                    <th
                      mat-header-cell
                      class="header-row-border orgApp-table-header-ht orgApp-duties-in-week-row"
                      *matHeaderCellDef
                    >
                      {{ "duties.map_duty_dialog.content.mon" | translate }}
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element; let i = index"
                      [ngClass]="{ disableTableRow: !element.value.active }"
                      [formGroup]="element"
                    >
                      <mat-form-field
                        floatLabel="always"
                        appearance="outline"
                        class="orgApp-duties-in-week-common-input orgApp-input-field orgApp-map-duty-field orgApp-field-rounded-sm orgApp-duties-in-week-field"
                      >
                        <input matInput type="text" formControlName="monday" (input)="onDayInputChange()" />
                      </mat-form-field>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="tuesday">
                    <th
                      mat-header-cell
                      class="header-row-border orgApp-table-header-ht orgApp-duties-in-week-row"
                      *matHeaderCellDef
                    >
                      {{ "duties.map_duty_dialog.content.tue" | translate }}
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element; let i = index"
                      [ngClass]="{ disableTableRow: !element.value.active }"
                      [formGroup]="element"
                    >
                      <mat-form-field
                        floatLabel="always"
                        appearance="outline"
                        class="orgApp-duties-in-week-common-input orgApp-input-field orgApp-map-duty-field orgApp-field-rounded-sm orgApp-duties-in-week-field"
                      >
                        <input matInput type="text" formControlName="tuesday" (input)="onDayInputChange()" />
                      </mat-form-field>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="wednesday">
                    <th
                      mat-header-cell
                      class="header-row-border orgApp-table-header-ht orgApp-duties-in-week-row"
                      *matHeaderCellDef
                    >
                      {{ "duties.map_duty_dialog.content.wed" | translate }}
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element; let i = index"
                      [ngClass]="{ disableTableRow: !element.value.active }"
                      [formGroup]="element"
                    >
                      <mat-form-field
                        floatLabel="always"
                        appearance="outline"
                        class="orgApp-duties-in-week-common-input orgApp-input-field orgApp-map-duty-field orgApp-field-rounded-sm orgApp-duties-in-week-field"
                      >
                        <input
                          matInput
                          type="text"
                          formControlName="wednesday" (input)="onDayInputChange()"
                        />
                      </mat-form-field>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="thursday">
                    <th
                      mat-header-cell
                      class="header-row-border orgApp-table-header-ht orgApp-duties-in-week-row"
                      *matHeaderCellDef
                    >
                      {{ "duties.map_duty_dialog.content.thu" | translate }}
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element; let i = index"
                      [ngClass]="{ disableTableRow: !element.value.active }"
                      [formGroup]="element"
                    >
                      <mat-form-field
                        floatLabel="always"
                        appearance="outline"
                        class="orgApp-duties-in-week-common-input orgApp-input-field orgApp-map-duty-field orgApp-field-rounded-sm orgApp-duties-in-week-field"
                      >
                        <input
                          matInput
                          type="text"
                          formControlName="thursday" (input)="onDayInputChange()"
                        />
                      </mat-form-field>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="friday">
                    <th
                      mat-header-cell
                      class="header-row-border orgApp-table-header-ht orgApp-duties-in-week-row"
                      *matHeaderCellDef
                    >
                      {{ "duties.map_duty_dialog.content.fri" | translate }}
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element; let i = index"
                      [ngClass]="{ disableTableRow: !element.value.active }"
                      [formGroup]="element"
                    >
                      <mat-form-field
                        floatLabel="always"
                        appearance="outline"
                        class="orgApp-duties-in-week-common-input orgApp-input-field orgApp-map-duty-field orgApp-field-rounded-sm orgApp-duties-in-week-field"
                      >
                        <input matInput type="text" formControlName="friday" (input)="onDayInputChange()" />
                      </mat-form-field>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="saturday">
                    <th
                      mat-header-cell
                      class="header-row-border orgApp-table-header-ht orgApp-duties-in-week-row"
                      *matHeaderCellDef
                    >
                      {{ "duties.map_duty_dialog.content.sat" | translate }}
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element; let i = index"
                      [ngClass]="{ disableTableRow: !element.value.active }"
                      [formGroup]="element"
                    >
                      <mat-form-field
                        floatLabel="always"
                        appearance="outline"
                        class="orgApp-duties-in-week-common-input orgApp-input-field orgApp-map-duty-field orgApp-field-rounded-sm orgApp-duties-in-week-field"
                      >
                        <input
                          matInput
                          type="text"
                          formControlName="saturday" (input)="onDayInputChange()"
                        />
                      </mat-form-field>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="sunday">
                    <th
                      mat-header-cell
                      class="header-row-border orgApp-table-header-ht orgApp-duties-in-week-row"
                      *matHeaderCellDef
                    >
                      {{ "duties.map_duty_dialog.content.sun" | translate }}
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element; let i = index"
                      [ngClass]="{ disableTableRow: !element.value.active }"
                      [formGroup]="element"
                    >
                      <mat-form-field
                        floatLabel="always"
                        appearance="outline"
                        class="orgApp-duties-in-week-common-input orgApp-input-field orgApp-map-duty-field orgApp-field-rounded-sm orgApp-duties-in-week-field"
                      >
                        <input matInput type="text" formControlName="sunday" (input)="onDayInputChange()" />
                      </mat-form-field>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="more">
                    <th
                      mat-header-cell
                      class="header-row-border orgApp-header-row"
                      *matHeaderCellDef
                      aria-label="row actions"
                    >
                      &nbsp;
                    </th>
                    <td mat-cell *matCellDef="let element; let i = index" class="orgApp-map-duty-more">
                      @if(!editMode[i]){
                      <button
                        mat-menu-item [disabled]="!canMapDuty"
                        (click)="deleteRow(element.memberTypeId, i, element)"
                      >
                      <svg width="20" height="20">
                        <use [attr.xlink:href]="canMapDuty ? '#delete-outline-grey-icon' : '#delete-outline-disabled'"></use>
                      </svg>
                      </button>
                      } @if(editMode[i]){
                      <mat-slide-toggle
                        [disabled]="(isPrevMonth || planningSheetPublished || !canMapDuty)&&!isAppAdmin"
                        class="orgApp-toggle-color"
                        [checked]="element.value.active"
                        (change)="
                          onActiveMemberChange($event.checked, element, i)
                        "
                        (click)="$event.stopPropagation()"
                      ></mat-slide-toggle>
                      }
                    </td>
                  </ng-container>
                  <!-- @if(showMemberRowDelete[i] && !planningSheetPublished && !planningSheetSaved){ -->
                    <ng-container matColumnDef="delete">
                      <th
                        mat-header-cell
                        class="orgApp-header-row"
                        *matHeaderCellDef
                        aria-label="row actions"
                      >
                        &nbsp;
                      </th>
                      <td mat-cell *matCellDef="let element; let i = index" class="orgApp-md-dlt-col">
                        @if(showMemberRowDelete[i] && !planningSheetPublished && !planningSheetSaved && canMapDuty){
                          <button class="orgApp-map-duty-dlt-btn orgApp-map-duty-more"
                            mat-menu-item 
                            (click)="deleteMemberRow(element.value.id)"
                          >
                          <svg width="20" height="20">
                            <use xlink:href="#delete-outline-grey-icon"></use>
                          </svg>
                          </button>
                        }
                      </td>
                    </ng-container>
                  <!-- }  -->
                  <tr
                    mat-header-row
                    class="orgApp-header-row"
                    *matHeaderRowDef="columnsToDisplayWithExpand"
                  ></tr>
                  <tr
                    mat-row [hidden]="!isEdit && (!isAppAdmin && (isPrevMonth || planningSheetPublished || dutyPublished || !canMapDuty))"
                    class="main-table-row"
                    *matRowDef="
                      let element;
                      columns: columnsToDisplayWithExpand
                    "
                  ></tr>
                  <hr />
                </table>
                @if (!isEdit && (!isAppAdmin && (isPrevMonth || planningSheetPublished || dutyPublished || !canMapDuty)) && !loadDetails) {
                <div
                  class="orgApp-margin-top-24 orgApp-padding-bottom-24 orgApp-d-flex orgApp-align-i-center orgApp-gap-16 orgApp-flex-dir-col orgApp-duty-map-disabled-msg-wrpr">
                  <svg width="32" height="32" viewBox="0 0 64 64">
                    <use xlink:href="#no-data-icon"></use>
                  </svg>
                  <p class="orgApp-margin-top-0 orgApp-margin-bottom-0">{{"duties.map_duty_dialog.content.cannot_config_msg" | translate}}</p>
                </div>
                }
              </ng-container>
            </div>
            }
          </form>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="orgApp-map-duty-action">
      <form [formGroup]="activateForm">
        <mat-slide-toggle
          class="orgApp-toggle-color"
          [disabled]="!isAppAdmin && (isPrevMonth || !canMapDuty)"
          [checked]="enableDutyMap"
          (change)="enableMapping($event.checked)"
          formControlName="active"
          (click)="$event.stopPropagation()"
          >{{
            "duties.map_duty_dialog.content.enable_mapping" | translate
          }}</mat-slide-toggle
        >
      </form>
      <span class="orgApp-spacer"></span>
      <div class="orgApp-add-duty-button-container orgApp-d-flex orgApp-gap-8">
        @if(!loadDetails) {
          @if(!isAppAdmin && (!isPrevMonth && canMapDuty && !planningSheetPublished && !dutyPublished)){
          <button
            class="orgapp-stroke-btn-primary orgApp-modal-button-secondary"
            mat-stroked-button
            (click)="cancelForm()"
          >
            {{ editFormData.cancelBtn | translate }}
          </button>
          }
          @if((!isPrevMonth && showMemberData)||isAppAdmin){
          <button
            mat-raised-button
            [ngClass]="{
              disable: editFormData.buttonName !== 'Close' && (!dutyChartForm.valid || !dutyChartForm.dirty  || !validMemberRow)
            }"
            class="orgApp-raised-btn-primary orgApp-modal-button-secondary"
            (click)="submitForm()"
            [disabled]="editFormData.buttonName !== 'Close'&& (!dutyChartForm.valid || !dutyChartForm.dirty || !validMemberRow)"
          >
            {{ editFormData.button | translate }}
          </button>
          } @if(isPrevMonth && !isAppAdmin){<!--added condition to check for app admin, since we have already added one in the above if block-->
          <button
            mat-raised-button
            class="orgApp-raised-btn-primary orgApp-modal-button-secondary"
            (click)="cancelForm()"
          >
            {{ editFormData.button | translate }}
          </button>
          } @if((!showMemberData) && canMapDuty){
          <button
            mat-raised-button
            [ngClass]="{
              disable: configdisable
            }"
            class="orgApp-raised-btn-primary orgApp-modal-button-secondary"
            (click)="submitForm()"
            [disabled]="configdisable"
          >
            {{ editFormData.button | translate }}
          </button>
          }
        }
        @else {
           <button
            class="orgApp-raised-btn-primary orgApp-modal-button-secondary"
            mat-raised-button
            (click)="cancelForm()"
          >
            {{ 'duties.map_duty_dialog.action.close_btn' | translate }}
          </button>
        }
      </div>
    </mat-dialog-actions>
  </div>
</div>
